/* unplugin-vue-components disabled */import { render } from "./Superior.vue?vue&type=template&id=bb9e1584&scoped=true"
import script from "./Superior.vue?vue&type=script&lang=js"
export * from "./Superior.vue?vue&type=script&lang=js"

import "./Superior.vue?vue&type=style&index=0&id=bb9e1584&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9e1584"]])

export default __exports__